import { category_cacheKey, retrieveData, storeData, url } from "./settings";
import * as actions from "../actionTypes";
import { Fetch } from "../../utilities/misc";

export const queryServices = async (
  params: {
    query?: string;
  } = {
    query: ""
  }
) => {
  return await Fetch(`${url.queryServices}?query=${params.query || ""}`).then(
    async (res) => {
      const {
        results
      }: { results: actions.service[]; suggetions: actions.service[] } =
        await res.json();

      return results;
    },
    (error) => {
      throw error;
    }
  );
};

export const getAllServices = async (
  params: {
    categories?: number[];
    exclude?: number[];
    limit?: number | ``;
    show_in?: "all" | "cleaning_product";
    background?: boolean;
    type?: string;
  } = {
    categories: [],
    exclude: [],
    limit: ""
  }
) => {
  const cacheKey = "all_services";
  const { categories, exclude, limit, background, type, show_in } = params;

  const fullLoad =
    (categories || []).length === 0 &&
    !limit &&
    (exclude || []).length === 0 &&
    !type;

  const response =
    ((fullLoad ? retrieveData(cacheKey) : null) as actions.service[]) || null;

  if (response && !background) {
    return response;
  } else {
    return await Fetch(
      `${url.getServices}?categories=${categories || ``}&exclude=${
        exclude || ``
      }&limit=${limit || ``}&type=${type || ""}&show_in=${show_in || "all"}`
    ).then(
      async (res) => {
        const result: actions.service[] = await res.json();

        if (fullLoad) {
          storeData(cacheKey, result);
        }

        return result;
      },
      (error) => {
        throw error;
      }
    );
  }
};

export const getUpsells = async ({
  services
}: {
  services: { id: number }[];
}) => {
  return await Fetch(url.getUpsells, {
    method: "POST",
    body: JSON.stringify({ services })
  }).then(
    async (res) => {
      const result: actions.service[] = await res.json();
      return result;
    },
    (error) => {
      throw error;
    }
  );
};

export const getAllCategories = async (param: { background?: boolean }) => {
  const { background } = param;

  const response =
    (retrieveData(category_cacheKey) as actions.category[]) || null;

  if (response && !background) {
    return response;
  } else {
    return await Fetch(`${url.getCategories}`).then(
      async (res) => {
        const result: actions.category[] = await res.json();
        storeData(category_cacheKey, result);

        return result;
      },
      (error) => {
        throw error;
      }
    );
  }
};

export const getServiceReviews = async (details: {
  serviceId: number | undefined;
}) => {
  const { serviceId } = details;
  if (!serviceId) {
    return;
  } else {
    return await Fetch(`${url.getReviews}?service_id=${serviceId}`).then(
      (res) => {
        const result: Promise<actions.reviews> = res.json();
        return result;
      },
      (error) => {
        throw error;
      }
    );
  }
};

export type rating = 1 | 2 | 3 | 4 | 5;
export const ratingArr = [1, 2, 3, 4, 5];
export type reviewParams = {
  token?: string;
  comment?: string;
  rate?: rating;
};

export type reviewResponse = { newlyRated: boolean };
export const leaveReview = async (params: reviewParams) => {
  const { rate, token } = params;
  // convert comment to undefined if it is an empty string
  const comment = params.comment || undefined;
  const Params = { ...params, comment };

  if (!rate || !token || !ratingArr.includes(rate)) {
    throw new Error("Invalid parameters");
  } else {
    return await Fetch(`${url.getReviews}`, {
      body: JSON.stringify(Params),
      method: "POST"
    }).then(
      (res) => {
        const result: Promise<reviewResponse> = res.json();
        return result;
      },
      (error) => {
        throw error;
      }
    );
  }
};
